import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../../app/state/app.selectors';
import * as fromExpType from './exp-type.reducers';

export interface ExpTypeState {
  stateData: fromExpType.State;
}

export interface State extends fromRoot.AppState {
  expType: ExpTypeState;
}

export const reducers = {
  stateData: fromExpType.reducer
};

export const selectExpTypeState = createFeatureSelector<ExpTypeState>('expType');

export const selectExpTypeStateData = createSelector(selectExpTypeState, (state: ExpTypeState) => state.stateData);

export const getExpTypeState = createSelector(selectExpTypeStateData, fromExpType.getStateData);

export const getExpTypeScreenError = createSelector(selectExpTypeStateData, fromExpType.getError);

export const getExpTypeScreenPending = createSelector(selectExpTypeStateData, fromExpType.getPending);